import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'

const DeleteBusModal = ({ show, handleClose, deleteId, onDelete, busName }) => {

  const handleDelete = async () => {
    try {
      const response = await ApiEndpoints.deleteBus(deleteId)

      toast.success(response?.data?.message || "Bus Deleted Successfully")

      onDelete(deleteId) // update parent UI 
      handleClose()
    } catch (error) {
      console.error(error)
      const errorData = error.response?.data

      if (errorData?.errors && typeof errorData.errors === "object") {
        Object.values(errorData.errors).forEach((errArr) => {
          if (Array.isArray(errArr)) {
            errArr.forEach((msg) => toast.error(msg))
          } else if (errArr) {
            toast.error(String(errArr))
          }
        })
      } else if (errorData?.message) {
        toast.error(errorData.message)
      } else if (error.response) {
        toast.error("Request failed. Please try again.")
      } else {
        toast.error("Server not reachable")
      }
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className='bg-danger text-white'>
        <Modal.Title>Delete Bus</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ fontSize: '14px' }}>
          Are you sure you want to delete <strong> {busName ? `${busName}` : 'this'}</strong> vehicle?
          <hr />
          <div className="mt-3 text-muted fw-semibold" style={{ letterSpacing: '2px' }}>
            This action is irreversible and the vehicle will be permanently removed.
          </div>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button variant="danger" onClick={handleDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteBusModal